import React from 'react';

/**
 * Uppercase, letter-spaced section heading preceded by a short purple bar.
 * Optionally shows a count after the label and an action slot on the right.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Heading text.
 * @param {number} [props.count] - Optional count rendered as "(n)".
 * @param {React.ReactNode} [props.action] - Optional right-aligned action node.
 * @param {string} [props.color='bg-brand-500'] - Tailwind class for the bar colour.
 * @returns {JSX.Element}
 */
export default function SectionLabel({ children, count, action, color = 'bg-brand-500' }) {
  return (
    <div className="flex items-center gap-3 mb-3">
      <span className={`w-1 h-5 rounded-full ${color}`} />
      <h3 className="text-[13px] font-bold tracking-[0.12em] uppercase text-ink dark:text-gray-100">{children}</h3>
      {count != null && <span className="text-gray-400 dark:text-gray-500 text-[13px] tabular">({count})</span>}
      {action && <span className="ml-auto">{action}</span>}
    </div>
  );
}
